export default "__VITE_ASSET__5_WORxnp__"